/**
 * Nation-team labels in Goalserve tennis feeds (BJK Cup, Davis Cup, etc.).
 * e.g. "Algeria W", "Great Britain M" — one country flag image per country, shared across M/W.
 */

export function isTennisNationTeamCompetition(competition: string): boolean {
  const lower = String(competition || "").trim().toLowerCase();
  if (!lower) return false;
  return (
    lower.startsWith("teams -") ||
    lower.includes("davis cup") ||
    lower.includes("billie jean king cup") ||
    lower.includes("united cup")
  );
}

export type TennisNationTeamLabel = {
  country: string;
  gender: "M" | "W";
  label: string;
};

/** Parse "Algeria W" / "Great Britain M" into country + gender suffix. */
export function parseTennisNationTeamLabel(label: string): TennisNationTeamLabel | null {
  const raw = String(label || "").trim();
  const match = raw.match(/^(.+?)\s+([MW])$/);
  if (!match) return null;

  const country = match[1].trim();
  const gender = match[2] as "M" | "W";
  if (!country || country.length < 2) return null;
  if (/^[A-Z]\.?$/.test(country)) return null;

  return { country, gender, label: raw };
}
